import {
  FormSelectCode,
  FormSelectJSCode,
} from '../codeHighlights/forms/FromSelectCode';
import { Select2Code } from '../codeHighlights/forms/Select2Code';
const FormSelect = () => {
  return (
    <>
      <h2>Select</h2>
      <div className="input-group mb-3 w-100">
        <div className="input-group-text">Prepend</div>
        <select
          className="form-select form-select-sm"
          id="prepend-text-single-field"
          data-placeholder="Choose one thing"
        >
          <option></option>
          <option>Reactive</option>
          <option>Solution</option>
          <option>Conglomeration</option>
          <option>Algoritm</option>
          <option>Holistic</option>
        </select>
      </div>
      <div className="input-group mb-3">
        <div className="input-group-text">Prepend</div>
        <select
          className="form-select"
          data-placeholder="Choose anything"
          id="prepend-text-multiple-field"
          multiple
        >
          <option>Christmas Island</option>
          <option>South Sudan</option>
          <option>Jamaica</option>
          <option>Kenya</option>
          <option>French Guiana</option>
          <option>Mayotta</option>
          <option>Liechtenstein</option>
          <option>Denmark</option>
          <option>Eritrea</option>
          <option>Gibraltar</option>
          <option>Saint Helena, Ascension and Tristan da Cunha</option>
          <option>Haiti</option>
          <option>Namibia</option>
          <option>South Georgia and the South Sandwich Islands</option>
          <option>Vietnam</option>
          <option>Yemen</option>
          <option>Philippines</option>
          <option>Benin</option>
          <option>Czech Republic</option>
          <option>Russia</option>
        </select>
      </div>
      <div className="my-3">
        <label className="form-label" htmlFor="single-select-field2">
          Single selection
        </label>
        <select className="sel2 col-12" id="single-select-field2">
          <option></option>
          <option>Reactive</option>
          <option>Solution</option>
          <option>Conglomeration</option>
          <option>Algoritm</option>
          <option>Holistic</option>
        </select>
      </div>
      <label className="form-label" htmlFor="multiple-select-field">
        Multiple selections
      </label>
      <select
        className="sel2 col-12"
        multiple={true}
        id="multiple-select-field"
      >
        <option value="FHNW">Hochschulen der FHNW</option>
        <option value="APS">Hochschule für Angewandte Psychologie</option>
        <option value="APS">
          Hochschule für Architektur, Bau und Geomatik
        </option>
        <option value="HGK">Hochschule für Gestaltung und Kunst</option>
        <option value="HLS">Hochschule für Life Science</option>
        <option value="APS">Hochschule für Musik</option>
        <option value="PH">Pädagogische Hochschule</option>
        <option value="HSA">Hochschule für Soziale Arbeit</option>
        <option value="HT">Hochschule für Technik</option>
        <option value="HSW">Hochschule für Wirtschaft</option>
      </select>
      <div className="row mt-5">
        <div className="col-12">
          <h2>Select2 example</h2>
          <div className="mb-3">
            <label className="form-label" htmlFor="single-select-field">
              Select single - Standard
            </label>
            <select className="sel2 col-12" id="single-select-field">
              <option value="FHNW">Hochschulen der FHNW</option>
              <option value="APS">Hochschule für Angewandte Psychologie</option>
              <option value="APS">
                Hochschule für Architektur, Bau und Geomatik
              </option>
              <option value="HGK">Hochschule für Gestaltung und Kunst</option>
              <option value="HLS">Hochschule für Life Science</option>
              <option value="APS">Hochschule für Musik</option>
              <option value="PH">Pädagogische Hochschule</option>
              <option value="HSA">Hochschule für Soziale Arbeit</option>
              <option value="HT">Hochschule für Technik</option>
              <option value="HSW">Hochschule für Wirtschaft</option>
            </select>
          </div>
        </div>
        <div className="col-12 col-md-7 mt-5">
          <FormSelectCode />
        </div>

        <div className="col-12 col-md-5 mt-5">
          <FormSelectJSCode />
        </div>
      </div>
      <div className="row mt-5">
        <p>
          Die Form Select's erfordern das jQuery Plugin <strong>Select2</strong>
          :
        </p>
        <div className="col-12 mt-2">
          <Select2Code />
        </div>
      </div>
    </>
  );
};

export default FormSelect;
